module.exports = __webpack_public_path__ + "img/starter-motor-diagram.26cc9595.png";